export async function createBankAccount(bankAccountRepository, bankAccount) {
  return bankAccountRepository.save(bankAccount);
};

